<template>
  <card>
    <div class="row" style="margin-top: 10px;">
      <div class="col-6">
        <h5>Forecast for every 3 hours of next five days</h5>
      </div>
      <div class="col-6" style="margin-top: -10px">
        <div data-toggle="buttons" class="btn-group btn-group-toggle float-right">
          <label class="btn btn-sm btn-primary btn-simple active">
            <input type="radio"
                   name="options" autocomplete="off" checked>
            Hourly
          </label>
          <label class="btn btn-sm btn-primary btn-simple">
            <input type="radio"
                   @click="getCurrent()"
                   name="options" autocomplete="off">
            Daily
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <forecast-table :forecast="forecast" :showScroll="true"></forecast-table>
      </div>
    </div>
  </card>
</template>

<script>

  import ForecastItem from "./ForecastItem";
  import ForecastTable from "./ForecastTable";
  export default {
    components: {ForecastTable, ForecastItem},
    props: ['forecast'],
    name: "ForecastWeatherCard",
    methods:{
      getCurrent(){
        this.$emit('switch', 'current')
      },
    }
  }
</script>

<style scoped>
  .row{
    margin-top: -10px;
  }
  .description{
    float: right;
  }
</style>
